import React from 'react';
import BaseIcon, { IconProps } from '../Base.icon';

const PersonWithCatIcon = ({ width = 270, height = 270 }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 270 270">
      <path
        d="M224.102 133.219C224.102 163.248 208.406 189.606 184.779 204.518H95.2038C71.5776 189.606 55.8812 163.248 55.8812 133.219C55.8812 86.7066 93.5392 49 139.992 49C186.445 49 224.102 86.7066 224.102 133.219Z"
        fill="white"
      />
      <path
        d="M131.231 192.758L122.124 190.419C120.94 190.115 119.687 190.23 118.578 190.745L114.85 192.475C113.645 193.035 112.694 194.025 112.185 195.253L111.295 197.396C110.701 198.827 111.751 200.403 113.299 200.403H119.155C119.437 200.403 119.718 200.353 119.983 200.253L123.008 199.126C123.505 198.986 124.033 199.008 124.515 199.192L125.873 199.709C126.549 199.966 127.271 200.083 127.994 200.05L131.23 199.905"
        fill="#FDBD91"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M131.23 192.759V194.574L122.47 192.327C121.287 192.022 120.032 192.136 118.925 192.652L115.197 194.38C113.99 194.94 113.039 195.931 112.531 197.161L111.641 199.301C111.61 199.376 111.582 199.453 111.562 199.529C111.127 198.947 110.981 198.151 111.296 197.395L112.185 195.252C112.693 194.026 113.644 193.035 114.851 192.475L118.579 190.743C119.686 190.23 120.942 190.116 122.124 190.418L131.23 192.759Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M119.155 201.47H113.299C112.216 201.47 111.21 200.932 110.608 200.029C110.007 199.126 109.896 197.99 110.312 196.987L111.202 194.844C111.815 193.366 112.952 192.182 114.403 191.508L118.13 189.778C119.458 189.162 120.971 189.022 122.389 189.386L131.496 191.725C131.967 191.846 132.297 192.271 132.297 192.758V199.906C132.297 200.476 131.848 200.946 131.279 200.972L128.043 201.117C127.171 201.156 126.313 201.018 125.495 200.707L124.138 200.19C123.883 200.092 123.599 200.076 123.335 200.144L120.355 201.254C119.97 201.398 119.566 201.47 119.155 201.47ZM131.231 199.906H131.234H131.231ZM120.81 191.321C120.197 191.321 119.587 191.453 119.027 191.714L115.299 193.444C114.334 193.891 113.578 194.68 113.17 195.663L112.28 197.806C112.136 198.153 112.173 198.531 112.381 198.844C112.59 199.157 112.924 199.336 113.3 199.336H119.156C119.313 199.336 119.466 199.309 119.613 199.254L122.638 198.127C122.665 198.117 122.692 198.108 122.719 198.101C123.431 197.899 124.205 197.932 124.896 198.195L126.254 198.712C126.798 198.919 127.369 199.013 127.948 198.985L130.167 198.886V193.586L121.861 191.453C121.515 191.364 121.162 191.321 120.81 191.321Z"
        fill="#404851"
      />
      <path
        d="M147.389 124.011V140.986C147.389 149.06 153.861 155.621 161.891 155.756V161.837C161.655 167.264 165.101 169.175 169.516 168.693C174.302 168.176 180.234 164.846 183.846 160.149V133.593L172.346 130.207C172.346 130.207 169.479 127.745 170.215 119.269C170.215 119.269 151.632 121.666 147.821 119.745C147.541 121.053 147.41 122.485 147.389 124.011Z"
        fill="#FDBD91"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M147.389 124.011V140.986C147.389 149.06 153.861 155.621 161.891 155.756V161.838C161.658 167.21 165.031 169.135 169.381 168.706C166.154 168.344 163.904 166.257 164.096 161.838V155.756C156.066 155.621 149.594 149.06 149.594 140.986V124.011C149.611 122.69 149.712 121.441 149.921 120.283C149.028 120.165 148.303 119.989 147.82 119.746C147.541 121.053 147.41 122.485 147.389 124.011Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M175.86 152.636V161.274C175.452 164.577 172.886 166.829 169.516 168.693C174.302 168.176 180.234 164.847 183.846 160.149V137.176L174.67 137.595C174.723 145.483 174.022 152.7 167.793 154.972L168.467 155.759L172.706 154.746L175.86 152.636Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M183.845 146.98V133.594L172.345 130.209C172.345 130.209 169.478 127.747 170.215 119.27C170.215 119.27 151.631 121.668 147.821 119.745C147.542 121.053 147.411 122.485 147.389 124.011V124.021C124.119 114.703 143.224 84.0285 166.476 98.0785L183.847 102.655C186.826 91.6003 194.09 96.034 188.366 104.769C202.597 104.918 209.949 136.403 183.845 146.98Z"
        fill="#404851"
      />
      <path
        d="M172.799 130.342L172.345 130.208C172.345 130.208 169.749 127.978 170.133 120.461C170.906 120.369 171.356 120.311 171.356 120.311C170.86 126.025 172.001 129.008 172.799 130.342Z"
        fill="#404851"
      />
      <path
        d="M173.189 130.646L172.228 130.345C172.119 130.252 169.569 127.971 169.953 120.452L169.961 120.3L170.112 120.283C170.883 120.192 171.333 120.133 171.333 120.133L171.554 120.105L171.535 120.327C171.037 126.063 172.21 129.007 172.953 130.25L173.189 130.646ZM170.306 120.622C169.996 127.333 172.102 129.712 172.422 130.033C171.68 128.59 170.745 125.675 171.159 120.518C170.976 120.541 170.686 120.577 170.306 120.622Z"
        fill="#404851"
      />
      <path
        d="M183.845 134.3L184.986 134.636V146.495C184.612 146.66 184.232 146.821 183.845 146.979V134.3Z"
        fill="#404851"
      />
      <path
        d="M183.665 147.247V134.06L185.166 134.501V146.613L185.058 146.66C184.683 146.825 184.301 146.988 183.913 147.147L183.665 147.247ZM184.025 134.541V146.711C184.289 146.601 184.549 146.49 184.807 146.377V134.771L184.025 134.541Z"
        fill="#404851"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M143.81 100.256C144.09 102.871 142.636 104.272 140.408 104.251C137.17 109.455 137.018 115.967 141.82 120.8C128.016 109.376 144.985 86.0204 165.623 97.5812C156.944 93.6681 148.929 95.7526 143.81 100.256Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M172.799 130.342L183.845 133.593V134.3L173.486 131.251C173.487 131.251 173.183 130.988 172.799 130.342Z"
        fill="#404851"
      />
      <path
        d="M184.025 134.541L173.37 131.387C173.357 131.375 173.038 131.098 172.645 130.435L172.411 130.041L184.025 133.459V134.541ZM173.578 131.089L183.665 134.06V133.728L173.215 130.652C173.39 130.897 173.524 131.037 173.578 131.089Z"
        fill="#404851"
      />
      <path
        d="M161.927 154.857C162.165 154.845 162.505 154.839 162.797 154.84C163.099 154.835 163.401 154.851 163.703 154.856L165.516 154.928L169.141 155.077L169.02 155.088C170.864 154.837 172.669 154.26 174.276 153.289C175.88 152.321 177.28 150.983 178.389 149.416C178.447 149.335 178.559 149.315 178.64 149.373C178.717 149.427 178.738 149.531 178.692 149.61C177.71 151.304 176.403 152.861 174.765 154.03C173.137 155.208 171.23 155.998 169.262 156.433C169.241 156.438 169.219 156.44 169.198 156.441L169.141 156.444L165.516 156.593L163.703 156.665C163.401 156.67 163.099 156.686 162.797 156.681C162.484 156.681 162.22 156.681 161.854 156.657C161.359 156.624 160.984 156.196 161.017 155.701C161.047 155.24 161.418 154.883 161.868 154.861L161.927 154.857Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M182.827 133.294L183.846 133.594V146.98C202.398 139.463 204.05 121.387 198.344 111.503C199.437 122.167 197.022 125.298 192.318 123.518C191.495 118.854 189.006 117.939 189.006 117.939C189.006 117.939 188.645 106.458 188.366 104.77C188.086 103.081 184.744 103.476 184.744 103.476L186.15 107.262L185.887 119.658C187.233 120.012 188.244 120.85 188.969 121.711C188.524 121.414 188.066 121.09 187.597 120.738L182.827 133.294Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M183.984 102.172C184.511 103.074 184.318 103.798 184.318 103.798C185.414 101.561 187.654 96.8237 190.193 97.2561C190.197 97.2561 190.197 97.2561 190.197 97.2561C190.241 97.2663 190.281 97.2729 190.325 97.2831L190.062 96.9995L189.459 96.3476C188.045 95.4326 185.519 96.9215 183.984 102.172Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M183.846 133.594L174.521 130.849C174.531 130.863 174.538 130.869 174.538 130.869L183.846 133.612V133.594Z"
        fill="white"
      />
      <path
        d="M184.026 133.851L174.443 131.029L174.377 130.957L174.052 130.523L184.026 133.459V133.851Z"
        fill="#404851"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M170.215 119.27C171.254 118.976 172.277 119.796 172.213 120.876C172.075 123.187 172.249 125.263 172.706 127.127L171.415 129.139C171.414 129.139 169.91 121.163 170.215 119.27Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M143.316 115.123C147.205 119.897 158.102 119.758 169.584 119.209L151.173 120.406C151.173 120.406 143.98 118.68 143.316 115.123Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M183.845 147.88C183.669 147.88 183.494 147.827 183.343 147.726C183.095 147.559 182.947 147.279 182.947 146.979V134.267L172.093 131.071C171.97 131.036 171.857 130.974 171.761 130.891C171.635 130.783 168.811 128.259 169.242 120.297C165.3 120.772 153.233 122.079 148.52 120.931C148.38 121.864 148.304 122.884 148.288 124.023C148.284 124.319 148.134 124.6 147.888 124.764C147.641 124.928 147.33 124.966 147.055 124.856C140.417 122.197 136.48 117.58 135.97 111.854C135.446 105.98 138.712 99.9304 144.29 96.4417C150.883 92.3164 159.092 92.6087 166.829 97.2393L183.228 101.56C184.378 97.8795 186.196 95.5339 188.176 95.2255C189.214 95.0644 190.183 95.5128 190.771 96.4263C191.658 97.8058 191.819 100.462 189.88 103.997C195.508 104.901 200.256 110.486 201.706 118.161C203.532 127.825 200.039 141.39 184.183 147.814C184.074 147.858 183.96 147.88 183.845 147.88ZM172.832 129.413L184.099 132.73C184.482 132.842 184.745 133.195 184.745 133.593V145.616C198.537 139.415 201.59 127.235 199.938 118.495C198.522 110.999 193.759 105.725 188.355 105.668C188.026 105.664 187.726 105.482 187.571 105.191C187.417 104.901 187.433 104.549 187.613 104.274C189.716 101.063 189.941 98.4606 189.258 97.4004C188.984 96.9746 188.666 96.9695 188.451 97.0038C187.616 97.1336 185.89 98.5196 184.712 102.888C184.584 103.366 184.094 103.65 183.616 103.523L166.246 98.9469C166.163 98.925 166.084 98.8915 166.01 98.847C158.842 94.5154 151.272 94.1953 145.241 97.967C140.232 101.1 137.296 106.488 137.759 111.692C138.176 116.367 141.278 120.23 146.537 122.671C146.604 121.531 146.738 120.506 146.941 119.554C146.999 119.282 147.18 119.052 147.432 118.932C147.683 118.811 147.976 118.814 148.225 118.94C151.148 120.415 165.006 119.032 170.1 118.375C170.368 118.34 170.64 118.429 170.836 118.618C171.033 118.807 171.133 119.075 171.11 119.346C170.518 126.168 172.353 128.842 172.832 129.413Z"
        fill="#404851"
      />
      <path
        d="M143.223 114.702C143.427 115.267 143.662 115.805 144.016 116.264C144.362 116.723 144.748 117.14 145.199 117.478C145.643 117.821 146.122 118.113 146.621 118.353C146.872 118.472 147.126 118.581 147.383 118.674C147.63 118.767 147.918 118.857 148.128 118.899C148.62 118.998 148.939 119.478 148.84 119.971C148.741 120.464 148.262 120.783 147.77 120.684C147.689 120.668 147.612 120.641 147.542 120.606L147.514 120.591C147.172 120.418 146.921 120.255 146.647 120.067C146.38 119.884 146.126 119.687 145.881 119.482C145.391 119.069 144.945 118.608 144.557 118.108C144.162 117.614 143.856 117.051 143.621 116.48C143.376 115.907 143.279 115.292 143.223 114.702Z"
        fill="#404851"
      />
      <path
        d="M168.265 169.67C167.15 169.67 166.107 169.508 165.175 169.168C162.323 168.126 160.838 165.516 160.993 161.817V156.615C152.918 156.02 146.489 149.187 146.489 140.986V124.011C146.513 122.32 146.661 120.867 146.942 119.556C147 119.284 147.181 119.053 147.432 118.933C147.684 118.813 147.976 118.816 148.225 118.941C151.149 120.417 165.008 119.034 170.1 118.377C170.369 118.342 170.641 118.431 170.837 118.62C171.034 118.808 171.134 119.076 171.11 119.347C170.518 126.167 172.352 128.841 172.831 129.413L184.099 132.73C184.482 132.842 184.744 133.194 184.744 133.593V160.148C184.744 160.346 184.678 160.54 184.557 160.697C180.45 166.039 173.556 169.67 168.265 169.67ZM148.52 120.931C148.38 121.864 148.304 122.884 148.288 124.023V140.986C148.288 148.508 154.397 154.729 161.908 154.855C162.398 154.863 162.792 155.264 162.792 155.754V161.837C162.792 161.85 162.792 161.863 162.791 161.876C162.663 164.818 163.672 166.703 165.792 167.477C170.337 169.138 178.441 165.509 182.947 159.839V134.268L172.093 131.072C171.97 131.036 171.857 130.974 171.761 130.892C171.635 130.784 168.811 128.26 169.242 120.298C165.299 120.772 153.233 122.079 148.52 120.931Z"
        fill="#404851"
      />
      <path
        d="M161.891 156.601C161.426 156.601 161.048 156.223 161.048 155.757C161.048 155.291 161.426 154.904 161.891 154.904C162.356 154.904 162.734 155.274 162.734 155.74V155.757C162.734 156.223 162.357 156.601 161.891 156.601Z"
        fill="#404851"
      />
      <path
        d="M166.474 98.0762C172.808 98.0762 177.94 103.216 177.94 109.557V136.403H186.149V109.557C186.149 108.866 186.089 108.19 185.971 107.531C185.016 102.156 180.325 98.0762 174.683 98.0762H166.474V98.0762Z"
        fill="#C5D3E2"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M178.539 118.993C178.539 118.993 182.65 120.04 186.272 120.738V109.557C186.272 108.866 186.212 108.19 186.094 107.531C184.876 115.11 182.36 118.932 178.539 118.993Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M166.474 98.0762C172.808 98.0762 177.94 103.216 177.94 109.557V136.403H186.149V135.735H179.681V108.889C179.681 103.908 176.514 99.6664 172.082 98.0762H166.474V98.0762Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M186.149 137.269H177.94C177.463 137.269 177.076 136.882 177.076 136.404V109.558C177.076 103.705 172.32 98.9423 166.474 98.9423C165.996 98.9423 165.61 98.5552 165.61 98.0769C165.61 97.5986 165.996 97.2114 166.474 97.2114H174.683C181.482 97.2114 187.013 102.75 187.013 109.558V136.404C187.014 136.881 186.627 137.269 186.149 137.269ZM178.806 135.538H185.285V109.557C185.285 103.704 180.529 98.9416 174.683 98.9416H172.766C176.379 101.097 178.805 105.049 178.805 109.557V135.538H178.806Z"
        fill="#404851"
      />
      <path
        d="M182.126 141.632C187.527 141.632 191.906 136.517 191.906 130.207C191.906 123.898 187.527 118.783 182.126 118.783C176.725 118.783 172.346 123.898 172.346 130.207C172.346 136.517 176.725 141.632 182.126 141.632Z"
        fill="#C5D3E2"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M172.433 131.733C173.07 137.322 177.169 141.631 182.126 141.631C187.529 141.631 191.906 136.515 191.906 130.207C191.906 128.553 191.606 126.979 191.06 125.557C191.117 126.056 191.147 126.567 191.147 127.083C191.147 133.391 186.769 138.507 181.367 138.507C177.384 138.507 173.954 135.725 172.433 131.733Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M172.346 130.207C172.346 134.202 174.103 137.721 176.764 139.76C174.973 137.69 173.863 134.817 173.863 131.642C173.863 129.744 174.258 127.954 174.963 126.381C177.479 125.534 178.457 124.058 178.265 122.103C179.809 120.911 181.657 120.219 183.643 120.219C185.623 120.219 187.468 120.908 189.006 122.089C187.238 120.047 184.81 118.784 182.126 118.784C176.723 118.784 172.346 123.899 172.346 130.207Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M182.126 142.497C176.256 142.497 171.481 136.984 171.481 130.207C171.481 123.431 176.256 117.917 182.126 117.917C187.996 117.917 192.77 123.43 192.77 130.207C192.77 136.984 187.996 142.497 182.126 142.497ZM182.126 119.649C177.21 119.649 173.21 124.385 173.21 130.207C173.21 136.029 177.21 140.766 182.126 140.766C187.042 140.766 191.042 136.029 191.042 130.207C191.042 124.385 187.042 119.649 182.126 119.649Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M186.287 124.622C186.676 124.841 187.033 125.112 187.36 125.429C187.033 125.108 186.676 124.838 186.287 124.622Z"
                    fill="#6B184E"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M187.235 125.559C186.918 125.251 186.569 124.988 186.199 124.779L186.376 124.465C186.773 124.687 187.147 124.968 187.486 125.301L187.235 125.559Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M185.313 124.207C185.566 124.285 185.816 124.383 186.051 124.497C185.816 124.379 185.566 124.281 185.313 124.207Z"
                    fill="#6B184E"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M185.973 124.659C185.746 124.549 185.506 124.454 185.26 124.378L185.363 124.033C185.628 124.111 185.887 124.213 186.132 124.335L185.973 124.659Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M184.585 136.405C187.185 136.405 189.293 133.63 189.293 130.207C189.293 126.785 187.185 124.01 184.585 124.01C181.985 124.01 179.877 126.785 179.877 130.207C179.877 133.63 181.985 136.405 184.585 136.405Z"
        fill="#C5D3E2"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M179.877 130.207C179.877 132.625 180.929 134.719 182.46 135.735C181.546 134.607 180.976 133.003 180.976 131.224C180.976 127.8 183.084 125.024 185.685 125.024C186.45 125.024 187.172 125.267 187.812 125.696C186.973 124.649 185.832 124.011 184.585 124.011C181.984 124.011 179.877 126.783 179.877 130.207Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M180.19 132.426C180.864 134.753 182.577 136.404 184.584 136.404C187.185 136.404 189.293 133.632 189.293 130.207C189.293 128.877 188.976 127.647 188.433 126.638C188.635 127.327 188.746 128.073 188.746 128.857C188.746 132.281 186.638 135.054 184.038 135.054C182.446 135.053 181.04 134.016 180.19 132.426Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M184.585 137.097C181.607 137.097 179.186 134.006 179.186 130.207C179.186 126.409 181.607 123.318 184.585 123.318C187.562 123.318 189.984 126.409 189.984 130.207C189.984 134.006 187.562 137.097 184.585 137.097ZM184.585 124.703C182.371 124.703 180.569 127.172 180.569 130.207C180.569 133.243 182.371 135.712 184.585 135.712C186.799 135.712 188.601 133.243 188.601 130.207C188.602 127.172 186.8 124.703 184.585 124.703Z"
        fill="#404851"
      />
      <path d="M184.494 136.92H184.49V135.57L184.494 136.92Z" fill="#404851" />
      <path
        d="M154.868 129.196C154.241 129.044 153.667 128.893 153.117 128.783C152.567 128.67 152.042 128.608 151.53 128.598C151.272 128.58 151.023 128.619 150.764 128.626C150.515 128.681 150.25 128.692 149.995 128.775C149.725 128.821 149.471 128.928 149.188 129.012C148.902 129.095 148.642 129.241 148.311 129.327L148.289 129.332C148.217 129.351 148.144 129.308 148.126 129.236C148.118 129.204 148.121 129.172 148.134 129.144C148.424 128.54 148.879 127.986 149.495 127.631C149.789 127.426 150.134 127.318 150.476 127.198C150.829 127.125 151.189 127.058 151.549 127.074C152.27 127.081 152.969 127.281 153.567 127.612C154.164 127.95 154.685 128.395 155.031 129.001C155.068 129.066 155.045 129.149 154.981 129.186C154.949 129.203 154.914 129.208 154.882 129.2L154.868 129.196Z"
        fill="#404851"
      />
      <path
        d="M167.672 134.866C167.699 132.782 166.473 131.077 164.934 131.058C163.394 131.038 162.124 132.711 162.096 134.795C162.069 136.879 163.295 138.584 164.835 138.603C166.375 138.623 167.645 136.949 167.672 134.866Z"
        fill="#404851"
      />
      <path
        d="M161.812 128.792C162.106 128.156 162.624 127.696 163.238 127.37C163.855 127.053 164.611 126.923 165.336 127.05C165.52 127.062 165.693 127.126 165.867 127.179C166.042 127.233 166.214 127.293 166.368 127.384C166.526 127.471 166.682 127.557 166.83 127.652C166.965 127.765 167.1 127.873 167.227 127.989C167.29 128.048 167.357 128.101 167.413 128.164L167.571 128.363C167.674 128.496 167.776 128.628 167.866 128.766C168.029 129.054 168.165 129.354 168.267 129.662C168.29 129.732 168.252 129.808 168.182 129.831C168.147 129.843 168.112 129.839 168.081 129.824L168.065 129.816C167.771 129.67 167.526 129.502 167.28 129.349C167.146 129.286 167.024 129.217 166.902 129.15C166.783 129.079 166.666 129.012 166.54 128.966C166.416 128.917 166.3 128.859 166.183 128.806L165.827 128.692C165.714 128.64 165.592 128.63 165.476 128.605C165.361 128.579 165.246 128.551 165.128 128.549C164.662 128.497 164.188 128.526 163.672 128.611C163.155 128.693 162.608 128.835 161.983 128.978L161.967 128.982C161.893 128.998 161.82 128.953 161.802 128.878C161.796 128.85 161.8 128.819 161.812 128.792Z"
        fill="#404851"
      />
      <path
        d="M165.239 133.959C165.278 133.321 164.873 132.777 164.334 132.744C163.795 132.711 163.326 133.202 163.287 133.84C163.248 134.477 163.654 135.021 164.193 135.054C164.732 135.087 165.2 134.597 165.239 133.959Z"
        fill="white"
      />
      <path
        d="M164.241 135.174C164.221 135.174 164.202 135.173 164.182 135.172C163.883 135.154 163.612 135 163.418 134.74C163.228 134.486 163.136 134.161 163.157 133.821C163.2 133.115 163.723 132.564 164.338 132.607C164.946 132.644 165.406 133.25 165.363 133.956C165.322 134.641 164.824 135.174 164.241 135.174ZM164.279 132.86C163.829 132.86 163.444 133.288 163.411 133.838C163.394 134.116 163.469 134.383 163.622 134.588C163.77 134.787 163.974 134.903 164.198 134.917C164.663 134.946 165.075 134.508 165.109 133.941C165.144 133.374 164.79 132.89 164.322 132.861C164.308 132.861 164.294 132.86 164.279 132.86Z"
        fill="#404851"
      />
      <path
        d="M154.728 134.866C154.755 132.782 153.529 131.077 151.989 131.058C150.45 131.038 149.179 132.711 149.152 134.795C149.125 136.879 150.351 138.584 151.89 138.603C153.43 138.623 154.7 136.949 154.728 134.866Z"
        fill="#404851"
      />
      <path
        d="M152.293 133.959C152.332 133.321 151.927 132.777 151.388 132.744C150.849 132.711 150.38 133.202 150.341 133.84C150.302 134.477 150.708 135.021 151.247 135.054C151.786 135.087 152.255 134.597 152.293 133.959Z"
        fill="white"
      />
      <path
        d="M151.296 135.174C151.276 135.174 151.257 135.173 151.237 135.172C150.939 135.154 150.667 135 150.473 134.74C150.284 134.486 150.191 134.161 150.213 133.821C150.256 133.115 150.78 132.564 151.394 132.607C152.002 132.644 152.462 133.25 152.418 133.956C152.377 134.641 151.879 135.174 151.296 135.174ZM151.335 132.86C150.885 132.86 150.499 133.288 150.466 133.838C150.449 134.116 150.524 134.383 150.677 134.588C150.826 134.787 151.03 134.903 151.253 134.917C151.718 134.946 152.131 134.508 152.165 133.941L152.291 133.949L152.165 133.941C152.199 133.375 151.847 132.89 151.378 132.861C151.364 132.861 151.349 132.86 151.335 132.86Z"
        fill="#404851"
      />
      <path
        d="M165.006 143.237C165.006 143.237 164.011 144.475 160.709 145.59C160.009 145.882 157.921 146.461 154.533 144.967C154.533 144.967 156.893 148.017 160.976 146.639C160.976 146.638 163.371 146.066 165.006 143.237Z"
        fill="#404851"
      />
      <path
        d="M158.908 147.358C155.969 147.358 154.268 145.213 154.248 145.187C154.148 145.056 154.148 144.875 154.249 144.745C154.35 144.615 154.526 144.57 154.677 144.637C157.914 146.065 159.877 145.546 160.571 145.258C163.725 144.192 164.718 143.021 164.727 143.01C164.847 142.865 165.056 142.836 165.211 142.943C165.364 143.049 165.411 143.255 165.317 143.417C163.624 146.346 161.163 146.964 161.059 146.989C160.284 147.251 159.564 147.358 158.908 147.358ZM156.358 145.993C157.387 146.553 158.91 146.956 160.861 146.298C160.898 146.289 161.983 146.009 163.156 144.964C162.545 145.277 161.777 145.61 160.824 145.932C160.222 146.183 158.711 146.607 156.358 145.993Z"
        fill="#404851"
      />
      <path
        d="M187.361 96.4926C185.495 97.9246 184.318 99.969 183.822 102.62C181.935 98.8687 176.655 98.214 174.707 98.0981C174.248 98.074 173.974 98.0769 173.974 98.0769H168.588C166.732 98.0769 165.225 99.5855 165.225 101.447V106.947C165.225 111.112 160.274 111.112 160.274 106.947V100.776H156.635V106.87C156.635 111.136 151.218 111.136 151.218 106.87V96.6625L160.055 89.3072L160.633 88.826C161.75 85.4561 164.994 83.0245 168.853 81.979L169.051 81.9272C174.154 80.6199 180.28 81.7289 183.996 86.2843C185.326 87.9205 186.352 89.9984 186.905 92.5707C187.13 93.6068 187.279 94.7252 187.34 95.9253C187.348 96.112 187.354 96.3008 187.361 96.4926Z"
        fill="white"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M156.634 100.777H160.274V101.511H158.603V107.605C158.603 110.762 155.636 111.584 154.094 110.064C155.39 109.982 156.635 108.915 156.635 106.871V100.777H156.634Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M174.707 98.0982C175.876 98.1682 178.243 98.4306 180.355 99.4419C178.876 99.0212 177.485 98.8812 176.676 98.8324C176.216 98.8083 175.942 98.8112 175.942 98.8112H170.556C168.7 98.8112 167.193 100.32 167.193 102.181V107.681C167.193 110.789 164.44 111.578 163.039 110.048C164.174 109.899 165.224 108.863 165.224 106.947V101.447C165.224 99.5855 166.731 98.077 168.587 98.077H173.973C173.974 98.077 174.248 98.0741 174.707 98.0982Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M159.635 96.4773L160.055 89.3073L160.633 88.8261C161.75 85.4561 164.994 83.0245 168.853 81.979C172.875 87.4706 166.473 96.0967 159.635 96.4773Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M180.031 82.5323C176.847 85.5735 181.31 90.2573 184.493 87.2161C183.28 85.3832 181.83 83.7842 180.031 82.5323Z"
        fill="#BDCAD9"
      />
      <path
        d="M171.44 97.8947C172.583 91.1658 181.405 92.6684 180.263 99.3967C180.263 99.3967 175.6 97.5265 171.44 97.8947Z"
        fill="#BDCAD9"
      />
      <path
        d="M162.749 110.791C161.162 110.791 159.555 109.471 159.555 106.947V101.497H157.354V106.872C157.354 109.445 155.629 110.791 153.926 110.791C152.223 110.791 150.499 109.445 150.499 106.872V96.664C150.499 96.4504 150.593 96.247 150.758 96.1099L160.019 88.4018C161.739 83.594 167.587 80.3728 174.03 80.7206C181.032 81.0975 186.108 85.4707 187.607 92.4199C187.844 93.5128 187.996 94.6808 188.058 95.8904C188.067 96.0815 188.074 96.2747 188.079 96.4708C188.087 96.7027 187.982 96.9236 187.798 97.065C186.089 98.3774 184.989 100.291 184.529 102.754C184.472 103.058 184.228 103.291 183.923 103.334C183.619 103.378 183.319 103.22 183.18 102.945C181.074 98.7566 174.047 98.7959 173.984 98.7974H168.076C166.901 98.7974 165.945 99.7547 165.945 100.931V106.947C165.944 109.471 164.337 110.791 162.749 110.791ZM156.634 100.057H160.274C160.67 100.057 160.993 100.379 160.993 100.777V106.947C160.993 108.599 161.903 109.351 162.749 109.351C163.595 109.351 164.506 108.599 164.506 106.947V100.931C164.506 98.9607 166.107 97.3574 168.075 97.3574H173.973C174.257 97.3552 180.426 97.3224 183.515 100.885C184.136 98.9461 185.178 97.361 186.628 96.1558C186.626 96.0902 186.623 96.026 186.619 95.9612C186.563 94.831 186.421 93.7417 186.2 92.7246C184.846 86.4477 180.268 82.4982 173.952 82.1584C168.151 81.8522 162.718 84.8109 161.314 89.0536C161.272 89.1812 161.195 89.2949 161.091 89.381L151.937 97.0009V106.871C151.937 108.583 152.936 109.35 153.926 109.35C154.916 109.35 155.916 108.583 155.916 106.871V100.777C155.916 100.379 156.237 100.057 156.634 100.057Z"
        fill="#404851"
      />
      <path
        d="M164.506 83.1339C163.483 77.1961 161.12 73.0424 161.12 73.0424C160.019 74.1302 158.867 76.4167 157.713 78.752L164.506 83.1339Z"
        fill="#BDCAD9"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M164.506 83.1347L157.711 78.7527C158.867 76.4159 160.018 74.1302 161.12 73.0424C161.12 73.0424 161.351 73.4477 161.695 74.1849C160.755 75.3945 159.781 77.3324 158.807 79.301L164.474 82.9575C164.485 83.0158 164.498 83.0734 164.506 83.1347Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M164.506 83.8536C164.371 83.8536 164.236 83.8157 164.117 83.7391L157.324 79.3572C157.017 79.1589 156.907 78.7608 157.069 78.4327C158.381 75.7773 159.475 73.657 160.616 72.5298C160.775 72.3723 160.998 72.2987 161.219 72.3293C161.441 72.3599 161.635 72.4919 161.746 72.6866C161.845 72.8608 164.182 77.0189 165.216 83.0115C165.264 83.2929 165.142 83.5766 164.904 83.734C164.783 83.8135 164.645 83.8536 164.506 83.8536ZM158.643 78.4947L163.47 81.6087C162.719 78.2643 161.604 75.6541 160.974 74.338C160.191 75.4266 159.366 77.0364 158.643 78.4947Z"
        fill="#404851"
      />
      <path
        d="M159.782 79.3309C159.782 79.3309 160.36 77.8573 160.815 76.7797C160.869 76.6514 161.049 76.6514 161.102 76.7797C161.348 77.3703 161.85 78.7191 162.203 80.5915L159.782 79.3309Z"
        fill="#404851"
      />
      <path
        d="M149.052 79.1946L148.942 79.2821L142.739 84.2444C142.929 81.476 143.442 79.0583 143.94 77.2508C144.522 75.1335 145.083 73.8605 145.083 73.8605C146.29 74.8302 147.667 76.9876 149.052 79.1946Z"
        fill="white"
      />
      <path
        d="M142.739 84.9648C142.626 84.9648 142.511 84.9378 142.406 84.8824C142.153 84.7497 142.002 84.4799 142.022 84.1949C142.442 78.1279 144.345 73.7533 144.426 73.5696C144.516 73.3647 144.696 73.2138 144.914 73.1605C145.131 73.1073 145.36 73.1583 145.534 73.2983C146.783 74.3023 148.087 76.3008 149.662 78.8097C149.856 79.1195 149.788 79.5271 149.502 79.7553L143.189 84.8059C143.058 84.9108 142.899 84.9648 142.739 84.9648ZM145.361 75.1357C144.868 76.5115 144.023 79.2253 143.615 82.6222L148.102 79.0328C147.234 77.6562 146.25 76.1382 145.361 75.1357Z"
        fill="#404851"
      />
      <path
        d="M147.052 79.9805C147.052 79.9805 146.328 78.5733 145.766 77.5482C145.699 77.4265 145.52 77.4447 145.48 77.5774C145.296 78.1898 144.933 79.5832 144.772 81.481L147.052 79.9805Z"
        fill="#404851"
      />
      <path
        d="M159.864 96.3592C156.453 98.1856 152.366 98.3941 148.787 96.922C147.5 96.3949 146.382 95.692 145.445 94.871C143.819 93.4486 142.742 91.6637 142.285 89.7957C141.896 88.2085 141.957 86.5578 142.514 85.0171C143.352 82.6927 145.009 80.6301 148.623 79.3607C150.711 78.6265 152.921 78.3108 155.117 78.4209C156.166 78.4734 157.215 78.6221 158.244 78.8693C162.021 79.7763 163.887 81.6961 164.939 83.9629C165.14 84.3989 165.303 84.848 165.421 85.3059C166.463 89.2671 164.458 93.897 159.864 96.3592Z"
        fill="white"
      />
      <path
        d="M147.197 91.978C147.262 93.2474 146.533 94.3716 145.444 94.8711C143.819 93.4486 142.742 91.6637 142.285 89.7958C142.765 89.4028 143.37 89.1534 144.036 89.1199C145.697 89.0346 147.113 90.3149 147.197 91.978Z"
        fill="#BDCAD9"
      />
      <path
        d="M165.422 85.3068C164.359 86.7395 162.687 87.7027 160.767 87.8004C157.344 87.9754 154.429 85.3397 154.255 81.9121C154.19 80.6405 154.512 79.4382 155.117 78.4211C156.167 78.4736 157.215 78.6224 158.244 78.8695C162.021 79.7766 163.888 81.6963 164.94 83.9631C165.141 84.3998 165.303 84.849 165.422 85.3068Z"
        fill="#BDCAD9"
      />
      <path
        d="M153.731 98.6232C151.965 98.6232 150.196 98.2805 148.514 97.5901C142.995 95.3218 140.062 89.6916 141.837 84.7723C142.907 81.81 144.987 79.8749 148.385 78.6821C151.616 77.5483 155.083 77.3712 158.412 78.1703C161.919 79.0124 164.268 80.8082 165.592 83.6605C167.807 88.4303 165.49 94.1625 160.203 96.9937C158.18 98.0764 155.959 98.6232 153.731 98.6232ZM149.061 96.2573C152.466 97.6564 156.28 97.4617 159.524 95.7236C164.128 93.2584 166.175 88.3333 164.287 84.2671C163.144 81.8056 161.171 80.3131 158.076 79.5702C155.016 78.8352 151.829 78.9978 148.86 80.0404C145.902 81.0787 144.1 82.7381 143.189 85.2608C141.677 89.4532 144.255 94.2828 149.061 96.2573Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M159.863 96.3585C156.451 98.1864 152.365 98.3942 148.786 96.9221C147.499 96.395 146.382 95.6914 145.444 94.8711C144.367 93.9262 143.53 92.8238 142.958 91.6412C143.074 91.7542 143.193 91.8636 143.315 91.97C144.252 92.7924 145.369 93.4938 146.656 94.021C150.235 95.4931 154.322 95.2853 157.733 93.4603C162.328 90.9981 164.334 86.3668 163.293 82.4056C163.174 81.9513 163.009 81.5037 162.812 81.0713C163.774 81.912 164.446 82.8992 164.939 83.9629C165.14 84.3989 165.305 84.8495 165.423 85.3067C166.464 89.2679 164.458 93.8963 159.863 96.3585Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M145.809 86.988C145.849 86.5549 146.084 86.1437 146.425 85.8426C146.767 85.54 147.21 85.3504 147.664 85.2943C148.118 85.236 148.585 85.3074 148.993 85.4992C149.397 85.6902 149.752 86.0088 149.909 86.4193C149.501 86.2691 149.146 86.1875 148.793 86.1459C148.443 86.1051 148.103 86.1073 147.771 86.1481C147.439 86.1897 147.116 86.2713 146.796 86.4062C146.473 86.5396 146.161 86.7307 145.809 86.988Z"
        fill="#404851"
      />
      <path
        d="M158.475 86.6468C158.099 86.4266 157.769 86.2684 157.434 86.1685C157.102 86.0672 156.772 86.0191 156.438 86.011C156.103 86.0045 155.765 86.0365 155.42 86.1131C155.074 86.1897 154.729 86.3078 154.338 86.4981C154.452 86.0737 154.773 85.7208 155.156 85.489C155.542 85.2571 155.999 85.1383 156.457 85.15C156.915 85.1602 157.375 85.3038 157.745 85.5692C158.115 85.8353 158.392 86.2196 158.475 86.6468Z"
        fill="#404851"
      />
      <path
        d="M153.324 88.4964C153.345 88.9069 152.698 89.2736 151.88 89.3152C151.062 89.3567 150.381 89.0578 150.36 88.6473C150.339 88.2368 150.996 88.0728 151.814 88.0312C152.634 87.9889 153.304 88.0852 153.324 88.4964Z"
        fill="#404851"
      />
      <path
        d="M152.211 88.8947C152.168 89.335 151.979 89.7835 151.658 90.1188C151.341 90.4579 150.907 90.6693 150.466 90.7364C150.025 90.8049 149.562 90.7284 149.187 90.4994C148.806 90.2807 148.549 89.8957 148.471 89.5057C148.465 89.4772 148.483 89.4495 148.512 89.4444C148.533 89.44 148.555 89.4502 148.566 89.4685C148.763 89.7915 149.05 90.0197 149.368 90.1181C149.687 90.2158 150.024 90.2005 150.325 90.1028C150.628 90.0051 150.885 89.8192 151.08 89.5932C151.276 89.3642 151.407 89.0886 151.5 88.7773L151.506 88.7569C151.563 88.5658 151.764 88.4579 151.954 88.5148C152.123 88.5644 152.227 88.7262 152.211 88.8947Z"
        fill="#404851"
      />
      <path
        d="M152.203 88.7407C152.327 89.0411 152.486 89.3014 152.704 89.5092C152.921 89.7148 153.196 89.8738 153.507 89.9394C153.817 90.0057 154.154 89.986 154.461 89.857C154.768 89.7265 155.029 89.4706 155.193 89.1293C155.206 89.1031 155.237 89.0922 155.263 89.1053C155.283 89.1148 155.294 89.1359 155.292 89.1578C155.254 89.5537 155.037 89.9634 154.681 90.2194C154.332 90.4848 153.879 90.6087 153.432 90.5854C152.987 90.5635 152.533 90.3973 152.184 90.0925C151.83 89.7921 151.597 89.3648 151.509 88.931C151.47 88.7356 151.596 88.5453 151.791 88.506C151.963 88.471 152.13 88.565 152.195 88.7218L152.203 88.7407Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M187.361 96.4927C185.495 97.9246 184.318 99.9691 183.822 102.62C181.935 98.8688 176.655 98.2141 174.707 98.0982C181.159 97.7176 184.695 94.2499 183.983 86.2881C183.983 86.2881 183.986 86.2881 183.995 86.2852C185.325 87.9213 186.351 89.9992 186.904 92.5715C187.129 93.6076 187.278 94.726 187.34 95.9262C187.348 96.1121 187.354 96.3009 187.361 96.4927Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M205.259 189.207C205.259 192.287 203.994 195.245 201.735 197.37C199.664 199.32 196.927 200.404 194.081 200.404H165.623V197.144L127.998 196.564L127.999 190.253L146.733 189.628L150.395 173.737C151.371 169.427 153.419 166.639 156.518 163.494L163.803 155.74C161.892 163.921 180.112 162.013 183.845 154.128L196.809 161.284C201.228 163.72 204.083 168.26 204.369 173.304L205.242 188.571C205.255 188.785 205.259 188.994 205.259 189.207Z"
        fill="white"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M164.255 158.86L158.919 164.54C155.821 167.684 153.775 170.471 152.8 174.781L149.416 189.283C149.088 190.686 147.867 191.699 146.429 191.76L130.058 192.458L128.691 197.089L127.998 196.564V190.252L146.731 189.63L150.396 173.735C151.372 169.425 153.417 166.639 156.516 163.494L163.803 155.741C163.505 157.021 163.696 158.058 164.255 158.86Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M165.908 193.434L187.287 192.367C187.287 192.367 190.91 192.367 191.406 190.376C191.904 188.385 190.325 183.068 190.325 183.068L190.244 188.252L188.92 190.021L165.623 191.124L165.908 193.434Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M189.666 174.162C190.238 177.427 190.662 180.7 191.061 183.973L191.202 185.202C191.249 185.598 191.31 186.064 191.312 186.516C191.318 186.971 191.286 187.436 191.188 187.907C191.09 188.378 190.932 188.861 190.648 189.325C190.37 189.785 189.934 190.22 189.399 190.475C189.135 190.603 188.854 190.688 188.579 190.736C188.447 190.763 188.29 190.774 188.184 190.785L187.876 190.808L185.411 190.989C183.768 191.116 182.125 191.227 180.48 191.33C178.837 191.442 177.192 191.533 175.548 191.625C172.258 191.8 168.967 191.955 165.672 192.023L166.521 191.124V200.404L165.623 199.505H188.507L194.216 199.501C195.971 199.486 197.715 198.994 199.233 198.117C200.751 197.239 202.036 195.96 202.928 194.449C203.819 192.937 204.323 191.196 204.355 189.439C204.369 189.001 204.34 188.572 204.313 188.08L204.232 186.65L204.069 183.79L203.742 178.071L203.579 175.212C203.521 174.262 203.482 173.282 203.385 172.416C203.27 171.527 203.064 170.652 202.79 169.799C202.513 168.946 202.134 168.13 201.699 167.347C201.267 166.561 200.734 165.834 200.155 165.153C199.578 164.468 198.923 163.851 198.217 163.3C197.872 163.014 197.494 162.773 197.126 162.518C196.738 162.29 196.368 162.061 195.936 161.83L193.432 160.448L183.41 154.917L184.656 154.515C184.126 155.632 183.375 156.597 182.532 157.427C181.688 158.258 180.748 158.963 179.762 159.571C177.782 160.779 175.623 161.627 173.373 162.126C172.246 162.371 171.094 162.527 169.92 162.548C168.747 162.563 167.544 162.453 166.357 162.053C165.765 161.854 165.178 161.57 164.644 161.167C164.107 160.772 163.641 160.234 163.317 159.623C162.998 159.009 162.835 158.332 162.789 157.681C162.743 157.026 162.814 156.395 162.935 155.793L164.46 156.602L157.686 163.581C156.55 164.741 155.456 165.872 154.505 167.112C153.546 168.341 152.757 169.668 152.165 171.084C151.876 171.795 151.635 172.527 151.434 173.274C151.247 174.011 151.067 174.83 150.885 175.613L149.792 180.352L147.606 189.832C147.512 190.238 147.158 190.516 146.76 190.529L128.028 191.154L128.897 190.254V196.564C128.897 197.061 128.494 197.465 127.998 197.465C127.501 197.465 127.098 197.061 127.098 196.564V190.254C127.098 189.768 127.486 189.372 127.967 189.355L146.699 188.731L145.853 189.428L148.038 179.95L149.13 175.211C149.316 174.415 149.481 173.649 149.694 172.815C149.913 171.996 150.18 171.185 150.502 170.396C151.159 168.819 152.045 167.338 153.08 166.012C154.103 164.677 155.27 163.475 156.399 162.322L163.168 155.348L163.172 155.344C163.517 154.988 164.086 154.98 164.441 155.326C164.669 155.547 164.753 155.867 164.694 156.157C164.49 157.114 164.527 158.059 164.908 158.788C165.286 159.515 166.028 160.048 166.935 160.349C167.839 160.656 168.862 160.763 169.888 160.747C170.918 160.73 171.96 160.591 172.985 160.368C175.036 159.915 177.033 159.127 178.818 158.037C180.582 156.944 182.186 155.511 183.028 153.744L183.029 153.741C183.243 153.293 183.78 153.103 184.227 153.317C184.243 153.324 184.26 153.333 184.274 153.341L194.295 158.871L196.8 160.254C197.21 160.473 197.653 160.742 198.087 161C198.504 161.286 198.93 161.56 199.321 161.883C200.118 162.505 200.86 163.204 201.513 163.978C202.168 164.749 202.769 165.571 203.258 166.459C203.75 167.343 204.177 168.267 204.491 169.231C204.803 170.195 205.034 171.185 205.163 172.19C205.277 173.222 205.309 174.151 205.368 175.108L205.531 177.968L205.858 183.687L206.021 186.546L206.102 187.976C206.128 188.437 206.163 188.962 206.146 189.478C206.108 191.542 205.518 193.588 204.47 195.364C203.421 197.139 201.912 198.641 200.128 199.674C198.344 200.705 196.296 201.282 194.234 201.3L188.501 201.304H165.617C165.12 201.304 164.718 200.901 164.718 200.404V191.123C164.718 190.643 165.095 190.251 165.567 190.224C168.851 189.929 172.138 189.722 175.428 189.536C177.072 189.447 178.717 189.356 180.363 189.288C182.009 189.21 183.654 189.14 185.301 189.085L187.771 188.995L188.079 188.984C188.178 188.977 188.228 188.981 188.299 188.97C188.43 188.955 188.551 188.927 188.66 188.882C188.878 188.795 189.066 188.642 189.231 188.408C189.564 187.94 189.724 187.212 189.774 186.481C189.802 186.108 189.781 185.751 189.765 185.325L189.724 184.086C189.644 180.782 189.58 177.475 189.666 174.162Z"
        fill="#404851"
      />
      <path
        d="M135.998 182.111C135.637 182.207 135.278 182.258 134.922 182.261H58.2099C58.0847 182.267 57.9587 182.264 57.8364 182.258C55.9897 182.165 54.3288 180.902 53.8205 179.018L39.1982 125.075C38.5647 122.735 39.9453 120.324 42.2849 119.683C42.6672 119.579 43.056 119.528 43.4354 119.528C43.4951 119.528 43.5548 119.528 43.6145 119.537L120.079 119.531C120.127 119.528 120.174 119.528 120.222 119.528C122.158 119.528 123.93 120.817 124.459 122.774L139.081 176.717C139.718 179.06 138.338 181.474 135.998 182.111Z"
        fill="#EBEBEB"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M45.5509 119.536H45.1031C45.1955 119.531 45.288 119.528 45.3783 119.528C45.4373 119.528 45.4912 119.528 45.5509 119.536Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M45.5507 119.717H45.1029L45.0912 119.357C45.2594 119.346 45.4153 119.334 45.5784 119.359L45.5507 119.717Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.6">
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <path
                    opacity="0.6"
                    d="M118.244 119.532L116.953 121.924H116.715L115.836 124.217H42.3606C41.9157 124.217 41.5742 124.636 41.6885 125.066C41.6892 125.069 41.69 125.072 41.6907 125.075L56.3109 179.019C56.8228 180.917 58.5063 182.184 60.3646 182.261H58.7582C56.7681 182.334 54.9128 181.031 54.3681 179.019L39.7625 125.129L39.7479 125.075C39.1152 122.733 40.4943 120.323 42.8325 119.682C43.2169 119.579 43.6043 119.528 43.9851 119.528C44.0434 119.528 44.1024 119.528 44.1643 119.535H46.0997L118.244 119.532Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M134.837 183.332C132.374 183.332 130.231 181.697 129.584 179.297L114.961 125.355C114.175 122.453 115.895 119.447 118.796 118.655C119.357 118.503 119.922 118.418 120.486 118.472C122.855 118.58 124.861 120.193 125.485 122.496L140.109 176.439C140.492 177.844 140.305 179.316 139.581 180.582C138.857 181.85 137.684 182.759 136.277 183.141C136.275 183.141 136.273 183.141 136.271 183.142C135.86 183.252 135.445 183.314 135.039 183.329C134.972 183.33 134.904 183.332 134.837 183.332ZM135.998 182.11H136.002H135.998ZM120.264 120.593L120.226 120.594C119.939 120.594 119.646 120.634 119.356 120.713C117.588 121.196 116.538 123.027 117.018 124.796L131.641 178.74C132.046 180.243 133.416 181.247 134.963 181.196C135.209 181.187 135.464 181.148 135.721 181.08C136.577 180.847 137.291 180.294 137.732 179.522C138.173 178.751 138.287 177.855 138.054 176.999L123.431 123.054C123.048 121.643 121.816 120.658 120.365 120.601C120.331 120.6 120.298 120.597 120.264 120.593Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M136.101 182.367C135.769 182.455 135.434 182.507 135.103 182.519C133.112 182.591 131.258 181.289 130.715 179.276L116.092 125.332C115.458 122.991 116.838 120.579 119.179 119.94C119.562 119.837 119.949 119.784 120.329 119.784C120.388 119.784 120.448 119.784 120.508 119.792C122.367 119.864 124.047 121.134 124.561 123.032L139.184 176.975C139.822 179.316 138.439 181.732 136.101 182.367Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M58.0453 183.33C55.5827 183.331 53.439 181.696 52.7909 179.296L38.1685 125.353C37.3836 122.452 39.1028 119.448 42.0023 118.654C42.4713 118.525 42.9526 118.46 43.4332 118.46C43.4936 118.46 43.5766 118.46 43.6735 118.469L120.05 118.463C120.107 118.461 120.165 118.46 120.221 118.46C122.68 118.46 124.845 120.119 125.487 122.495L140.109 176.437C140.899 179.342 139.179 182.349 136.277 183.14C136.275 183.14 136.272 183.141 136.27 183.141C135.82 183.261 135.369 183.323 134.93 183.326H58.2274C58.1669 183.329 58.1058 183.33 58.0453 183.33ZM135.998 182.111H136.002H135.998ZM43.4536 120.592L43.4339 120.595C43.1427 120.595 42.8499 120.634 42.5645 120.713C40.7965 121.197 39.7465 123.028 40.2256 124.796L54.848 178.739C55.2535 180.241 56.6225 181.247 58.1706 181.195C58.1837 181.194 58.1961 181.194 58.2092 181.194H134.923C135.174 181.192 135.447 181.154 135.723 181.081C137.489 180.598 138.535 178.767 138.054 176.998L123.431 123.054C123.037 121.594 121.695 120.584 120.187 120.595C120.173 120.595 120.16 120.595 120.147 120.595C120.125 120.597 120.102 120.597 120.08 120.597L43.6145 120.603C43.5599 120.603 43.5067 120.6 43.4536 120.592Z"
        fill="#404851"
      />
      <path
        d="M84.9569 154.429C86.7685 153.751 87.2723 150.618 86.0822 147.43C84.8922 144.243 82.4589 142.209 80.6474 142.887C78.8358 143.565 78.332 146.699 79.522 149.886C80.7121 153.073 83.1454 155.107 84.9569 154.429Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M131.874 182.26H63.5955C73.7549 182.046 84.0213 180.502 92.9661 177.323L95.4718 167.94L98.9488 172.051C99.9362 173.218 101.622 173.502 102.938 172.725C114.603 165.835 121.877 154.885 119.712 138.809L130.902 180.422L131.874 182.26Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.32">
        <g opacity="0.32">
          <g opacity="0.32">
            <g opacity="0.32">
              <g opacity="0.32">
                <g opacity="0.32">
                  <path
                    opacity="0.32"
                    d="M50.8969 142.041C49.8928 138.078 49.378 134.79 51.9673 134.131C54.5567 133.473 57.4694 136.153 58.4742 140.115C59.4784 144.078 58.1932 147.824 55.6038 148.482C53.0144 149.14 51.9011 146.004 50.8969 142.041Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.32">
        <g opacity="0.32">
          <g opacity="0.32">
            <g opacity="0.32">
              <g opacity="0.32">
                <g opacity="0.32">
                  <path
                    opacity="0.32"
                    d="M54.7082 156C54.2982 154.382 54.1635 153.019 55.8762 152.584C57.5888 152.149 59.3095 153.109 59.7194 154.727C60.1294 156.346 59.0736 158.01 57.3616 158.446C55.649 158.881 55.1189 157.619 54.7082 156Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M148.091 199.056C148.091 199.597 147.853 200.09 147.466 200.446C147.079 200.802 146.545 201.022 145.955 201.022H132.101C130.921 201.022 129.964 200.141 129.964 199.056C129.964 198.512 130.203 198.021 130.59 197.664C130.976 197.308 131.511 197.088 132.101 197.088H145.953C147.135 197.088 148.091 197.969 148.091 199.056Z"
        fill="#B8C5D3"
      />
      <path
        d="M132.102 201.022H101.952C100.772 201.022 99.8138 200.141 99.8138 199.056C99.8138 198.512 100.053 198.021 100.441 197.664C100.827 197.308 101.362 197.088 101.952 197.088H132.101C131.51 197.088 130.977 197.308 130.59 197.664C130.203 198.021 129.964 198.512 129.964 199.056C129.964 200.141 130.921 201.022 132.102 201.022Z"
        fill="#B8C5D3"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M104.62 201.022H103.391C102.21 201.022 101.252 200.141 101.252 199.056C101.252 198.512 101.491 198.021 101.879 197.664C102.266 197.308 102.8 197.088 103.39 197.088H104.62C104.029 197.088 103.495 197.308 103.109 197.664C102.721 198.021 102.482 198.512 102.482 199.056C102.483 200.141 103.44 201.022 104.62 201.022Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M145.954 201.977H132.102C130.397 201.977 129.01 200.667 129.01 199.056C129.01 198.261 129.342 197.517 129.943 196.962C130.525 196.427 131.29 196.133 132.101 196.133H145.953C147.658 196.133 149.045 197.444 149.045 199.056C149.045 199.851 148.713 200.595 148.11 201.15C147.531 201.683 146.765 201.977 145.954 201.977ZM132.102 198.044C131.77 198.044 131.463 198.159 131.236 198.367C131.032 198.555 130.918 198.8 130.918 199.056C130.918 199.613 131.449 200.067 132.102 200.067H145.954C146.286 200.067 146.593 199.952 146.82 199.743C147.025 199.555 147.137 199.311 147.137 199.056C147.137 198.499 146.607 198.044 145.955 198.044H132.102V198.044Z"
        fill="#404851"
      />
      <path
        d="M132.102 201.977H101.952C100.247 201.977 98.8599 200.667 98.8599 199.056C98.8599 198.259 99.192 197.516 99.7956 196.961C100.376 196.427 101.142 196.133 101.952 196.133H132.102C132.629 196.133 133.055 196.561 133.055 197.088C133.055 197.616 132.629 198.044 132.102 198.044C131.77 198.044 131.463 198.159 131.236 198.367C131.032 198.555 130.918 198.8 130.918 199.056C130.918 199.613 131.449 200.067 132.102 200.067C132.629 200.067 133.055 200.494 133.055 201.022C133.055 201.549 132.629 201.977 132.102 201.977ZM101.952 198.044C101.621 198.044 101.314 198.159 101.087 198.367C100.881 198.556 100.768 198.8 100.768 199.056C100.768 199.613 101.299 200.067 101.952 200.067H129.201C129.077 199.752 129.01 199.411 129.01 199.056C129.01 198.704 129.075 198.363 129.199 198.044H101.952Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M148.091 199.201C148.091 199.743 147.853 200.235 147.466 200.591C147.079 200.947 146.545 201.167 145.955 201.167H132.101C130.921 201.167 129.964 200.286 129.964 199.201C129.964 198.658 130.203 198.166 130.59 197.809C130.976 197.453 131.511 197.233 132.101 197.233H145.953C147.135 197.234 148.091 198.115 148.091 199.201Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M92.7229 163.494L87.3832 182.265C87.3832 182.265 87.3832 182.265 87.3832 182.269C87.3832 182.269 87.3789 182.269 87.3789 182.274L84.8135 191.294L83.3048 196.602C82.6865 198.783 84.3191 200.951 86.5822 200.951H69.0079C67.0564 200.951 65.6496 199.082 66.1826 197.204L67.9593 190.957L75.7704 163.495H92.7229V163.494Z"
        fill="#EBEBEB"
      />
      <g opacity="0.82">
        <g opacity="0.82">
          <g opacity="0.82">
            <g opacity="0.82">
              <g opacity="0.82">
                <g opacity="0.82">
                  <path
                    opacity="0.82"
                    d="M92.7229 163.494L92.0712 165.79H75.2935L67.4824 193.253L66.0763 198.198C66.0552 197.874 66.0894 197.541 66.1826 197.204L67.9593 190.957L75.7704 163.494H92.7229V163.494Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M109.509 199.077C109.509 200.109 108.67 200.95 107.639 200.95H86.5823C84.3191 200.95 82.6873 198.782 83.3048 196.602L84.8136 191.294L92.7229 163.494L95.6247 168.188L87.9024 195.331C87.6338 196.27 88.3372 197.204 89.3129 197.204H107.637C108.67 197.204 109.509 198.044 109.509 199.077Z"
        fill="#B8C5D3"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M109.509 199.077C109.509 200.109 108.67 200.95 107.639 200.95H86.5823C84.3191 200.95 82.6873 198.782 83.3048 196.602L84.8136 191.294L92.7229 163.494L95.6247 168.188L87.9024 195.331C87.6338 196.27 88.3372 197.204 89.3129 197.204H107.637C108.67 197.204 109.509 198.044 109.509 199.077Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M86.5823 202.016H69.0079C67.7417 202.016 66.5773 201.436 65.8142 200.425C65.0503 199.413 64.8115 198.132 65.1574 196.912L74.7459 163.202C74.8762 162.743 75.2942 162.427 75.7704 162.427H92.7229C93.0571 162.427 93.3717 162.584 93.5734 162.852C93.7751 163.119 93.8392 163.465 93.7482 163.786L84.3301 196.894C84.1276 197.609 84.2674 198.36 84.7153 198.953C85.1616 199.544 85.8425 199.883 86.5823 199.883C87.1706 199.883 87.6476 200.361 87.6476 200.95C87.6476 201.539 87.1706 202.016 86.5823 202.016ZM76.5751 164.561L67.2072 197.495C67.0455 198.065 67.1569 198.665 67.5145 199.139C67.8713 199.611 68.4159 199.883 69.0079 199.883H82.7718C82.1135 198.816 81.9329 197.536 82.2803 196.31L91.3117 164.561H76.5751Z"
        fill="#404851"
      />
      <path
        d="M107.638 202.017H86.5822C85.1681 202.017 83.8676 201.368 83.015 200.239C82.1608 199.107 81.8928 197.675 82.2802 196.311L91.6984 163.202C91.8141 162.796 92.1586 162.496 92.5758 162.438C92.9938 162.379 93.4066 162.573 93.6287 162.933L96.5312 167.627C96.6892 167.882 96.7322 168.192 96.6499 168.48L88.9284 195.623C88.8796 195.792 88.9481 195.918 88.9932 195.977C89.0384 196.037 89.1396 196.137 89.3143 196.137H107.639C109.257 196.137 110.575 197.456 110.575 199.077C110.575 200.698 109.257 202.017 107.638 202.017ZM93.087 166.109L84.33 196.894C84.1276 197.609 84.2674 198.36 84.7152 198.953C85.1616 199.544 85.8424 199.883 86.5822 199.883H107.639C108.083 199.883 108.444 199.522 108.444 199.077C108.444 198.632 108.083 198.27 107.639 198.27H89.3136C88.5112 198.27 87.7735 197.903 87.2915 197.261C86.8087 196.62 86.658 195.809 86.8793 195.037L94.472 168.349L93.087 166.109Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M86.5822 200.95H69.0079C67.0564 200.95 65.6496 199.081 66.1826 197.204L67.9593 190.957C77.8377 194.895 87.1276 182.606 87.3789 182.273L84.8135 191.293L83.3048 196.601C82.6873 198.782 84.3191 200.95 86.5822 200.95Z"
                    fill="#EBEBEB"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M165.623 193.256L156.517 190.917C155.333 190.613 154.08 190.728 152.971 191.243L149.243 192.973C148.038 193.533 147.087 194.523 146.578 195.751L145.688 197.894C145.094 199.325 146.144 200.901 147.692 200.901H153.548C153.83 200.901 154.11 200.851 154.375 200.752L157.401 199.624C157.898 199.484 158.426 199.506 158.908 199.69L160.266 200.207C160.942 200.464 161.664 200.581 162.387 200.548L165.623 200.403"
        fill="#FDBD91"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M165.623 193.256V195.18L157.121 192.996C155.94 192.693 154.687 192.808 153.575 193.325L149.851 195.053C148.645 195.612 147.695 196.606 147.183 197.831L146.296 199.977C146.253 200.084 146.216 200.191 146.195 200.297C145.581 199.713 145.321 198.774 145.688 197.895L146.578 195.753C147.089 194.524 148.04 193.534 149.242 192.975L152.971 191.243C154.079 190.731 155.332 190.615 156.516 190.918L165.623 193.256Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M153.548 201.969H147.692C146.609 201.969 145.602 201.43 145.001 200.527C144.4 199.624 144.289 198.488 144.705 197.485L145.594 195.342C146.208 193.864 147.345 192.679 148.795 192.006L152.523 190.275C153.851 189.659 155.364 189.52 156.782 189.884L165.889 192.223C166.36 192.344 166.689 192.769 166.689 193.256V200.403C166.689 200.973 166.241 201.443 165.672 201.469L162.436 201.614C161.564 201.653 160.705 201.516 159.888 201.204L158.53 200.687C158.275 200.59 157.992 200.574 157.727 200.642L154.748 201.751C154.362 201.896 153.959 201.969 153.548 201.969ZM165.623 200.404H165.627H165.623ZM155.202 191.819C154.59 191.819 153.979 191.951 153.419 192.211L149.691 193.942C148.726 194.389 147.97 195.178 147.562 196.161L146.672 198.304C146.528 198.651 146.565 199.029 146.773 199.342C146.982 199.655 147.317 199.834 147.692 199.834H153.548C153.705 199.834 153.858 199.807 154.006 199.752L157.03 198.626C157.057 198.616 157.083 198.607 157.111 198.599C157.823 198.397 158.596 198.43 159.288 198.694L160.645 199.211C161.189 199.417 161.758 199.509 162.34 199.484L164.558 199.385V194.085L156.253 191.951C155.908 191.862 155.554 191.819 155.202 191.819Z"
        fill="#404851"
      />
      <path
        d="M156.283 190.63L159.429 172.638L158.399 190.875C158.366 191.464 157.862 191.915 157.274 191.882C156.685 191.848 156.235 191.344 156.268 190.755C156.271 190.714 156.276 190.669 156.283 190.63Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M205.259 189.207C205.259 192.287 203.994 195.245 201.735 197.37C199.945 199.056 197.656 200.097 195.227 200.344C195.845 199.955 196.429 199.508 196.966 199.004C199.225 196.875 200.49 193.918 200.49 190.841C200.49 190.627 200.486 190.414 200.474 190.201L199.6 174.938C199.314 169.89 196.459 165.35 192.04 162.917C190.014 161.8 187.622 161.526 185.41 162.199C176.91 164.783 167.324 161.394 167.324 161.394C173.486 161.07 178.481 159.841 181.54 157.123L181.498 157.098C182.503 156.236 183.322 155.241 183.846 154.128L196.809 161.284C201.229 163.72 204.084 168.26 204.369 173.304L205.243 188.571C205.255 188.785 205.259 188.994 205.259 189.207Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M237.479 206.306H32.4357C30.999 206.306 29.8347 205.14 29.8347 203.701C29.8347 202.263 30.999 201.097 32.4357 201.097H237.479C238.916 201.097 240.08 202.263 240.08 203.701C240.081 205.139 238.916 206.306 237.479 206.306Z"
        fill="#BDCAD9"
      />
      <g opacity="0.55">
        <g opacity="0.55">
          <g opacity="0.55">
            <g opacity="0.55">
              <g opacity="0.55">
                <g opacity="0.55">
                  <path
                    opacity="0.55"
                    d="M240.082 203.702C240.082 204.073 240.006 204.423 239.868 204.741C239.466 203.817 238.547 203.173 237.481 203.173H32.4342C31.7184 203.173 31.0682 203.464 30.5941 203.938C30.3662 204.167 30.1791 204.441 30.048 204.742C29.9097 204.423 29.8339 204.073 29.8339 203.703C29.8339 202.983 30.1245 202.332 30.5949 201.861C31.0689 201.386 31.7192 201.095 32.4349 201.095H237.482C238.916 201.095 240.082 202.262 240.082 203.702Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M237.479 207.265H32.4357C30.4725 207.265 28.8764 205.666 28.8764 203.701C28.8764 201.737 30.4732 200.138 32.4357 200.138H237.479C239.442 200.138 241.038 201.737 241.038 203.701C241.038 205.666 239.442 207.265 237.479 207.265ZM32.4357 202.056C31.5298 202.056 30.7922 202.794 30.7922 203.701C30.7922 204.609 31.5291 205.347 32.4357 205.347H237.479C238.385 205.347 239.123 204.609 239.123 203.701C239.123 202.794 238.386 202.056 237.479 202.056H32.4357Z"
        fill="#404851"
      />
      <path
        d="M232.816 164.704C233.08 164.003 232.725 163.218 232.024 162.953C231.325 162.688 230.54 163.044 230.275 163.746L229.94 164.637L232.47 165.622L232.816 164.704Z"
        fill="#EEEEEE"
      />
      <path
        d="M232.547 165.794L229.77 164.713L230.152 163.699C230.292 163.327 230.569 163.031 230.932 162.867C231.296 162.702 231.7 162.689 232.071 162.83C232.442 162.97 232.738 163.248 232.902 163.611C233.066 163.974 233.08 164.379 232.939 164.751L232.547 165.794ZM230.109 164.561L232.394 165.451L232.692 164.658C232.807 164.351 232.796 164.018 232.662 163.719C232.526 163.42 232.284 163.192 231.978 163.077C231.673 162.961 231.34 162.972 231.041 163.108C230.743 163.243 230.514 163.486 230.399 163.792L230.109 164.561Z"
        fill="#404851"
      />
      <path
        d="M223.282 182.323L225.823 183.282L228.799 175.375L226.252 174.435L223.282 182.323Z"
        fill="#EEEEEE"
      />
      <path
        d="M225.899 183.453L223.112 182.401L226.174 174.266L228.97 175.297L225.899 183.453ZM223.452 182.246L225.745 183.111L228.628 175.452L226.329 174.604L223.452 182.246Z"
        fill="#404851"
      />
      <path
        d="M229.94 164.637L226.252 174.435L228.799 175.375L232.47 165.623L229.94 164.637Z"
        fill="#88BE4A"
      />
      <path
        d="M213.716 184.87C213.371 184.87 213.054 184.647 212.947 184.303L207.862 167.915C207.515 166.797 207.534 165.621 207.917 164.514L208.976 161.451C209.061 161.205 209.258 161.017 209.507 160.942C209.755 160.868 210.024 160.918 210.229 161.077L212.871 163.121C213.766 163.813 214.414 164.75 214.746 165.832L219.849 182.441C219.914 182.652 219.89 182.88 219.782 183.072C219.675 183.265 219.494 183.405 219.281 183.459L213.917 184.845C213.85 184.862 213.782 184.87 213.716 184.87ZM210.131 163.039L209.44 165.041C209.17 165.821 209.157 166.649 209.401 167.436L214.258 183.09L218.063 182.107L213.207 166.305C212.973 165.544 212.517 164.884 211.887 164.397L210.131 163.039Z"
        fill="#404851"
      />
      <path
        d="M211.886 164.397L210.131 163.039L209.439 165.041C209.198 165.739 209.164 166.475 209.334 167.187L213.086 165.973C212.831 165.352 212.422 164.811 211.886 164.397Z"
        fill="#FEF5E7"
      />
      <path
        d="M213.206 166.306C213.171 166.192 213.13 166.082 213.086 165.973L209.334 167.187C209.354 167.271 209.376 167.354 209.401 167.436L214.258 183.09L218.062 182.108L213.206 166.306Z"
        fill="#F9C710"
      />
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <path
                    opacity="0.5"
                    d="M209.938 167.436C209.912 167.354 209.891 167.27 209.871 167.187L213.142 166.128C213.123 166.077 213.106 166.024 213.085 165.973L209.333 167.187C209.353 167.271 209.375 167.354 209.4 167.436L214.257 183.09L214.754 182.962L209.938 167.436Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M222.916 187.355H219.109C218.328 187.355 217.696 186.721 217.696 185.94V161.916C217.696 161.135 218.328 160.501 219.109 160.501H222.916C223.696 160.501 224.329 161.135 224.329 161.916V185.94C224.328 186.721 223.696 187.355 222.916 187.355Z"
        fill="#E2E2E2"
      />
      <path
        d="M222.916 188.148H219.109C217.893 188.148 216.903 187.157 216.903 185.94V161.917C216.903 160.699 217.893 159.709 219.109 159.709H222.916C224.132 159.709 225.121 160.7 225.121 161.917V185.94C225.121 187.157 224.131 188.148 222.916 188.148ZM219.109 161.295C218.767 161.295 218.488 161.574 218.488 161.917V185.94C218.488 186.283 218.767 186.562 219.109 186.562H222.916C223.258 186.562 223.537 186.284 223.537 185.94V161.917C223.537 161.574 223.259 161.295 222.916 161.295H219.109Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <path
                    opacity="0.5"
                    d="M219.307 186.478V162.454C219.307 162.119 219.579 161.846 219.914 161.846H223.516C223.48 161.544 223.226 161.309 222.915 161.309H219.108C218.773 161.309 218.501 161.582 218.501 161.917V185.94C218.501 186.276 218.773 186.549 219.108 186.549H219.314C219.311 186.525 219.307 186.502 219.307 186.478Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M226.292 185.128C226.196 185.128 226.099 185.111 226.008 185.076L221.96 183.549C221.543 183.391 221.334 182.926 221.49 182.51L228.767 163.178C229.047 162.435 229.599 161.846 230.321 161.518C231.044 161.192 231.85 161.165 232.592 161.445C233.334 161.725 233.922 162.277 234.249 163C234.576 163.724 234.602 164.531 234.323 165.274L227.045 184.606C226.97 184.806 226.818 184.968 226.624 185.057C226.519 185.104 226.405 185.128 226.292 185.128ZM223.282 182.323L225.822 183.282L232.815 164.704C232.943 164.365 232.931 163.996 232.782 163.665C232.633 163.334 232.363 163.081 232.024 162.953C231.684 162.825 231.315 162.836 230.985 162.987C230.655 163.136 230.403 163.406 230.275 163.746L223.282 182.323Z"
        fill="#404851"
      />
      <path
        d="M232.057 178.273C231.966 178.273 231.874 178.258 231.783 178.224C231.373 178.073 231.162 177.618 231.312 177.207L234.418 168.726C234.663 168.056 234.338 167.321 233.677 167.052L232.894 166.733C232.488 166.568 232.294 166.105 232.458 165.7C232.623 165.294 233.085 165.098 233.49 165.264L234.274 165.583C235.729 166.175 236.445 167.796 235.905 169.273L232.799 177.754C232.683 178.074 232.38 178.273 232.057 178.273Z"
        fill="#404851"
      />
      <path
        d="M208.615 167.958C208.388 167.958 208.177 167.813 208.104 167.585C208.013 167.303 208.167 167 208.45 166.909L213.27 165.348C213.553 165.256 213.855 165.412 213.946 165.695C214.037 165.977 213.883 166.28 213.6 166.371L208.78 167.931C208.725 167.949 208.669 167.958 208.615 167.958Z"
        fill="#404851"
      />
      <path
        d="M208.615 167.958C208.388 167.958 208.177 167.813 208.104 167.585C208.013 167.303 208.167 167 208.45 166.909L213.27 165.348C213.553 165.256 213.855 165.412 213.946 165.695C214.037 165.977 213.883 166.28 213.6 166.371L208.78 167.931C208.725 167.949 208.669 167.958 208.615 167.958Z"
        fill="#404851"
      />
      <path
        d="M216.11 183.479C215.941 183.479 215.784 183.37 215.732 183.199L210.701 166.785C210.637 166.576 210.755 166.354 210.964 166.29C211.173 166.225 211.395 166.343 211.459 166.552L216.489 182.966C216.553 183.175 216.436 183.397 216.227 183.461C216.188 183.473 216.149 183.479 216.11 183.479Z"
        fill="#404851"
      />
      <path
        d="M232.833 166.302C232.768 166.302 232.702 166.29 232.638 166.265L229.198 164.926C228.922 164.819 228.785 164.507 228.893 164.23C229 163.953 229.311 163.816 229.588 163.923L233.028 165.263C233.305 165.37 233.441 165.682 233.334 165.959C233.251 166.172 233.048 166.302 232.833 166.302Z"
        fill="#404851"
      />
      <path
        d="M229.202 176.061C229.14 176.061 229.078 176.05 229.016 176.027L225.385 174.688C225.107 174.585 224.964 174.276 225.067 173.998C225.169 173.719 225.478 173.576 225.756 173.679L229.388 175.018C229.666 175.121 229.809 175.43 229.706 175.709C229.626 175.927 229.42 176.061 229.202 176.061Z"
        fill="#404851"
      />
      <path
        d="M229.121 201.215H212.845C211.511 201.215 210.429 200.132 210.429 198.796V181.519C210.429 180.628 211.151 179.906 212.04 179.906H229.927C230.816 179.906 231.537 180.628 231.537 181.519V198.796C231.538 200.132 230.456 201.215 229.121 201.215Z"
        fill="#404851"
      />
      <path
        d="M229.121 202.022H212.845C211.069 202.022 209.623 200.574 209.623 198.795V181.518C209.623 180.184 210.707 179.099 212.04 179.099H229.927C231.259 179.099 232.343 180.184 232.343 181.518V198.795C232.343 200.574 230.898 202.022 229.121 202.022ZM212.04 180.712C211.596 180.712 211.235 181.074 211.235 181.518V198.795C211.235 199.685 211.957 200.408 212.845 200.408H229.121C230.01 200.408 230.732 199.685 230.732 198.795V181.518C230.732 181.074 230.371 180.712 229.927 180.712H212.04Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <path
                    opacity="0.5"
                    d="M213.524 187.569C213.524 186.424 213.139 185.433 212.577 184.942V182.326C212.577 181.881 212.938 181.519 213.382 181.519H230.732C230.732 181.074 230.371 180.713 229.927 180.713H212.04C211.596 180.713 211.234 181.074 211.234 181.519V184.762V190.379V198.796C211.234 199.668 211.929 200.378 212.793 200.407C212.657 200.17 212.577 199.896 212.577 199.603V190.198C213.139 189.706 213.524 188.715 213.524 187.569Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M220.219 163.623H218.117C217.821 163.623 217.58 163.383 217.58 163.085C217.58 162.788 217.82 162.547 218.117 162.547H220.219C220.516 162.547 220.757 162.788 220.757 163.085C220.757 163.382 220.516 163.623 220.219 163.623Z"
        fill="#404851"
      />
      <path
        d="M219.264 166.111H218.117C217.821 166.111 217.58 165.87 217.58 165.573C217.58 165.276 217.82 165.035 218.117 165.035H219.264C219.56 165.035 219.801 165.275 219.801 165.573C219.801 165.869 219.56 166.111 219.264 166.111Z"
        fill="#404851"
      />
      <path
        d="M220.219 168.598H218.117C217.821 168.598 217.58 168.357 217.58 168.06C217.58 167.762 217.82 167.522 218.117 167.522H220.219C220.516 167.522 220.757 167.762 220.757 168.06C220.757 168.357 220.516 168.598 220.219 168.598Z"
        fill="#404851"
      />
      <path
        d="M219.264 171.085H218.117C217.821 171.085 217.58 170.845 217.58 170.547C217.58 170.251 217.82 170.009 218.117 170.009H219.264C219.56 170.009 219.801 170.25 219.801 170.547C219.801 170.845 219.56 171.085 219.264 171.085Z"
        fill="#404851"
      />
      <path
        d="M220.219 173.573H218.117C217.821 173.573 217.58 173.333 217.58 173.035C217.58 172.739 217.82 172.497 218.117 172.497H220.219C220.516 172.497 220.757 172.738 220.757 173.035C220.757 173.333 220.516 173.573 220.219 173.573Z"
        fill="#404851"
      />
      <path
        d="M219.264 176.061H218.117C217.821 176.061 217.58 175.821 217.58 175.523C217.58 175.226 217.82 174.985 218.117 174.985H219.264C219.56 174.985 219.801 175.226 219.801 175.523C219.801 175.821 219.56 176.061 219.264 176.061Z"
        fill="#404851"
      />
      <path
        d="M220.219 178.549H218.117C217.821 178.549 217.58 178.308 217.58 178.011C217.58 177.714 217.82 177.473 218.117 177.473H220.219C220.516 177.473 220.757 177.713 220.757 178.011C220.757 178.308 220.516 178.549 220.219 178.549Z"
        fill="#404851"
      />
      <path
        d="M209.228 164.449L211.644 163.643L210.034 162.298L209.228 164.449Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <g opacity="0.2">
          <g opacity="0.2">
            <g opacity="0.2">
              <g opacity="0.2">
                <g opacity="0.2">
                  <path
                    opacity="0.2"
                    d="M222.115 160.686C222.115 160.686 223.726 176.816 217.551 178.429V179.504L223.727 179.773L224.532 177.354L223.996 161.224L222.115 160.686Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M212.45 166.331C212.45 166.331 215.403 175.74 211.644 177.085L212.585 179.639L217.744 179.664V177.889L213.927 165.927L212.45 166.331Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.2">
        <g opacity="0.2">
          <g opacity="0.2">
            <g opacity="0.2">
              <g opacity="0.2">
                <g opacity="0.2">
                  <path
                    opacity="0.2"
                    d="M232.318 162.836C232.318 162.836 232.587 164.181 229.902 163.912L229.499 164.584L232.989 165.929C232.989 165.928 234.332 163.24 232.318 162.836Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.2">
        <g opacity="0.2">
          <g opacity="0.2">
            <g opacity="0.2">
              <g opacity="0.2">
                <g opacity="0.2">
                  <path
                    opacity="0.2"
                    d="M227.754 174.934C227.754 174.934 227.217 177.891 224.532 177.353L224.666 179.369H227.619L228.962 175.874L227.754 174.934Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M213.666 187.714V192.307C213.666 194.381 211.987 196.062 209.916 196.062H205.108V193.485H209.327C210.302 193.485 211.093 192.694 211.093 191.718V188.242C211.093 187.266 210.302 186.475 209.327 186.475H205.108V183.958H209.916C211.987 183.959 213.666 185.64 213.666 187.714Z"
        fill="#E66E5F"
      />
      <path
        d="M209.916 196.15H205.021V193.398H209.328C210.253 193.398 211.005 192.645 211.005 191.719V188.242C211.005 187.316 210.253 186.563 209.328 186.563H205.021V183.87H209.916C212.032 183.87 213.754 185.595 213.754 187.714V192.307C213.754 194.426 212.033 196.15 209.916 196.15ZM205.197 195.974H209.916C211.936 195.974 213.578 194.329 213.578 192.307V187.714C213.578 185.692 211.936 184.047 209.916 184.047H205.197V186.387H209.328C210.35 186.387 211.181 187.22 211.181 188.243V191.719C211.181 192.742 210.35 193.574 209.328 193.574H205.197V195.974Z"
        fill="#404851"
      />
      <path
        d="M211.093 191.719C211.093 192.695 210.302 193.485 209.327 193.485H205.108V196.063H209.916C211.986 196.063 213.665 194.381 213.665 192.307V187.713C213.665 185.64 211.986 183.959 209.916 183.959H205.108V186.474H209.327C210.302 186.474 211.093 187.266 211.093 188.242V191.719Z"
        fill="#C5D3E2"
      />
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <g opacity="0.5">
                    <path
                      opacity="0.5"
                      d="M205.109 183.959V184.885H209.917C211.987 184.885 213.666 186.566 213.666 188.639V187.714C213.666 185.641 211.987 183.959 209.917 183.959H205.109Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M209.916 196.782H205.108C204.712 196.782 204.389 196.46 204.389 196.062V193.485C204.389 193.088 204.711 192.765 205.108 192.765H209.327C209.904 192.765 210.373 192.295 210.373 191.718V188.241C210.373 187.664 209.904 187.194 209.327 187.194H205.108C204.712 187.194 204.389 186.872 204.389 186.474V183.958C204.389 183.561 204.711 183.238 205.108 183.238H209.916C212.38 183.238 214.384 185.245 214.384 187.712V192.305C214.385 194.775 212.381 196.782 209.916 196.782ZM205.828 195.342H209.916C211.587 195.342 212.946 193.981 212.946 192.308V187.714C212.946 186.041 211.587 184.68 209.916 184.68H205.828V185.756H209.328C210.698 185.756 211.812 186.871 211.812 188.243V191.719C211.812 193.091 210.698 194.206 209.328 194.206H205.828V195.342Z"
        fill="#404851"
      />
      <path
        d="M203.054 201.215H197.948C195.59 201.215 193.679 199.301 193.679 196.941V183.104C193.679 182.235 194.382 181.53 195.251 181.53H205.751C206.619 181.53 207.323 182.234 207.323 183.104V196.941C207.323 199.301 205.412 201.215 203.054 201.215Z"
        fill="#E66E5F"
      />
      <path
        d="M203.054 201.303H197.948C195.545 201.303 193.591 199.346 193.591 196.94V183.103C193.591 182.187 194.336 181.441 195.251 181.441H205.751C206.666 181.441 207.411 182.187 207.411 183.103V196.94C207.411 199.346 205.456 201.303 203.054 201.303ZM195.251 181.618C194.433 181.618 193.767 182.285 193.767 183.104V196.941C193.767 199.25 195.642 201.127 197.948 201.127H203.054C205.36 201.127 207.235 199.25 207.235 196.941V183.104C207.235 182.285 206.569 181.618 205.751 181.618H195.251V181.618Z"
        fill="#404851"
      />
      <path
        d="M203.054 201.215H197.948C195.59 201.215 193.679 199.301 193.679 196.941V183.104C193.679 182.235 194.382 181.53 195.251 181.53H205.751C206.619 181.53 207.323 182.234 207.323 183.104V196.941C207.323 199.301 205.412 201.215 203.054 201.215Z"
        fill="#C5D3E2"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M194.244 199.065C194.98 200.35 196.364 201.215 197.948 201.215H203.054C205.412 201.215 207.323 199.302 207.323 196.942V183.105C207.323 182.346 206.788 181.714 206.076 181.565C206.084 181.623 206.087 181.682 206.087 181.742V191.698C205.32 197.253 202.356 199.737 197.698 199.852H196.712C195.794 199.852 194.942 199.561 194.244 199.065Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <path
                    opacity="0.5"
                    d="M193.681 183.104V196.941C193.681 198.123 194.16 199.193 194.934 199.966C194.856 199.688 194.814 199.394 194.814 199.091V189.409C196.235 189.069 196.235 186.086 194.814 185.747V183.23C194.814 182.921 195.066 182.67 195.376 182.67H207.263C207.074 182.011 206.468 181.531 205.751 181.531H195.252C194.383 181.531 193.681 182.234 193.681 183.104Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M203.054 201.935H197.948C195.197 201.935 192.96 199.694 192.96 196.94V183.103C192.96 181.838 193.987 180.81 195.25 180.81H205.75C207.013 180.81 208.041 181.838 208.041 183.103V196.94C208.042 199.694 205.805 201.935 203.054 201.935ZM195.251 182.25C194.781 182.25 194.399 182.633 194.399 183.104V196.941C194.399 198.901 195.991 200.496 197.948 200.496H203.055C205.012 200.496 206.605 198.901 206.605 196.941V183.104C206.605 182.633 206.223 182.25 205.752 182.25H195.251V182.25Z"
        fill="#404851"
      />
      <g opacity="0.18">
        <g opacity="0.18">
          <g opacity="0.18">
            <g opacity="0.18">
              <g opacity="0.18">
                <g opacity="0.18">
                  <path
                    opacity="0.18"
                    d="M200.194 196.217C200.822 196.771 202.057 196.392 202.953 195.373C203.849 194.354 204.067 193.078 203.439 192.526C202.812 191.972 202.135 192.843 201.239 193.862C200.343 194.882 199.566 195.664 200.194 196.217Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.18">
        <g opacity="0.18">
          <g opacity="0.18">
            <g opacity="0.18">
              <g opacity="0.18">
                <g opacity="0.18">
                  <path
                    opacity="0.18"
                    d="M197.814 197.975C197.647 197.595 197.98 197.357 198.434 197.157C198.887 196.957 199.288 196.872 199.455 197.252C199.622 197.632 199.389 198.102 198.936 198.301C198.483 198.501 197.98 198.354 197.814 197.975Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g opacity="0.5">
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <g opacity="0.5">
                    <path
                      opacity="0.5"
                      d="M199.705 178.664C199.496 178.664 199.326 178.494 199.326 178.284V177.757C199.326 177.273 198.933 176.88 198.45 176.88H193.895C192.917 176.88 192.121 176.083 192.121 175.103C192.121 174.123 192.917 173.326 193.895 173.326H204.47C204.905 173.326 205.258 172.972 205.258 172.537C205.258 172.103 204.905 171.748 204.47 171.748H195.677C195.467 171.748 195.298 171.578 195.298 171.368C195.298 171.158 195.467 170.989 195.677 170.989H204.47C205.323 170.989 206.017 171.683 206.017 172.538C206.017 173.392 205.323 174.087 204.47 174.087H193.895C193.336 174.087 192.88 174.543 192.88 175.104C192.88 175.664 193.335 176.12 193.895 176.12H198.45C199.351 176.12 200.085 176.854 200.085 177.758V178.285C200.085 178.494 199.915 178.664 199.705 178.664Z"
                      fill="#FFFAFA"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <g opacity="0.5">
                    <path
                      opacity="0.5"
                      d="M193.823 171.749H192.495C192.285 171.749 192.116 171.579 192.116 171.369C192.116 171.159 192.285 170.989 192.495 170.989H193.823C194.033 170.989 194.203 171.159 194.203 171.369C194.203 171.579 194.033 171.749 193.823 171.749Z"
                      fill="#FFFAFA"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.5">
          <g opacity="0.5">
            <g opacity="0.5">
              <g opacity="0.5">
                <g opacity="0.5">
                  <g opacity="0.5">
                    <path
                      opacity="0.5"
                      d="M196.346 169.355H190.083C189.874 169.355 189.704 169.185 189.704 168.975C189.704 168.765 189.874 168.596 190.083 168.596H196.346C196.556 168.596 196.726 168.765 196.726 168.975C196.726 169.185 196.556 169.355 196.346 169.355Z"
                      fill="#FFFAFA"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M38.5712 182.452C36.8935 180.513 35.7234 178.08 35.0767 175.158C34.3449 171.853 34.4978 168.747 34.6661 167.121C36.0532 167.737 38.537 169.035 40.8009 171.234C41.0077 171.435 41.2057 171.64 41.3994 171.845C41.5334 171.123 41.6987 170.435 41.8844 169.791C41.8997 169.74 41.9157 169.689 41.9303 169.638C38.3149 166.224 34.3427 164.898 34.1724 164.842C33.9088 164.756 33.6189 164.788 33.3801 164.929C33.1405 165.07 32.9738 165.309 32.9214 165.582C32.885 165.774 32.0425 170.34 33.1733 175.516C33.7602 178.202 34.7724 180.544 36.1806 182.517C36.3379 182.476 36.501 182.453 36.6671 182.453H38.5712V182.452Z"
        fill="#404851"
      />
      <path
        d="M42.2579 181.874C41.5028 179.917 41.1555 178.006 41.0805 176.205C41.0156 174.655 41.1504 173.188 41.3994 171.845C41.2057 171.639 41.0076 171.435 40.8008 171.234C38.537 169.035 36.0525 167.737 34.666 167.121C34.642 167.351 34.6194 167.612 34.5983 167.897C34.5983 167.897 34.5983 167.897 34.5983 167.898C34.4723 169.631 34.4483 172.319 35.0767 175.158C35.7233 178.08 36.8935 180.513 38.5712 182.452H42.2768C42.2725 182.257 42.2666 182.064 42.2579 181.874Z"
        fill="#88BE4A"
      />
      <g opacity="0.6">
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <g opacity="0.6">
                    <path
                      opacity="0.6"
                      d="M41.0718 175.437C41.0623 175.841 41.063 176.251 41.0805 176.668C41.1562 178.469 41.5028 180.381 42.2579 182.337C42.2594 182.375 42.2601 182.414 42.2616 182.452H42.2761C42.2725 182.257 42.2667 182.064 42.2572 181.873C41.5021 179.917 41.1548 178.005 41.0798 176.205C41.0688 175.945 41.0718 175.691 41.0718 175.437Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <g opacity="0.6">
                    <path
                      opacity="0.6"
                      d="M34.5976 168.361C34.5976 168.36 34.5976 168.36 34.5976 168.361C34.618 168.076 34.6413 167.814 34.6653 167.584C36.0525 168.2 38.5363 169.498 40.8001 171.697C40.9851 171.877 41.1613 172.06 41.3353 172.243C41.3572 172.111 41.3747 171.975 41.3987 171.845C41.205 171.638 41.0069 171.434 40.8001 171.234C38.5363 169.034 36.0517 167.736 34.6653 167.121C34.6413 167.35 34.6187 167.611 34.5976 167.896C34.5976 167.896 34.5976 167.896 34.5976 167.897C34.5517 168.524 34.5204 169.278 34.5277 170.117C34.5328 169.463 34.5605 168.87 34.5976 168.361Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M42.2761 182.452H42.4924C42.4101 182.258 42.3315 182.066 42.2572 181.873C42.2667 182.064 42.2725 182.257 42.2761 182.452Z"
        fill="#8BC34A"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M42.2761 182.452H42.4924C42.4101 182.258 42.3315 182.066 42.2572 181.873C42.2667 182.064 42.2725 182.257 42.2761 182.452Z"
                    fill="#616B6B"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M51.6979 182.452H56.4259C58.1145 180.5 59.2883 178.048 59.9328 175.101C60.6522 171.807 60.5007 168.736 60.3325 167.123C58.9323 167.745 56.415 169.062 54.1467 171.282C53.7077 171.712 53.2999 172.154 52.9198 172.609C53.345 175.508 53.203 178.918 51.6979 182.452Z"
        fill="#88BE4A"
      />
      <g opacity="0.6">
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <g opacity="0.6">
                    <path
                      opacity="0.6"
                      d="M54.146 171.745C56.4142 169.524 58.9315 168.208 60.3318 167.586C60.3981 168.222 60.4607 169.089 60.4694 170.105C60.4796 168.888 60.4075 167.854 60.3318 167.123C58.9315 167.745 56.4142 169.062 54.146 171.282C53.7069 171.712 53.2991 172.154 52.919 172.609C52.9387 172.741 52.9554 172.876 52.9722 173.011C53.3385 172.579 53.7273 172.155 54.146 171.745Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <g opacity="0.6">
                    <path
                      opacity="0.6"
                      d="M53.1244 175.663C53.0974 177.795 52.7021 180.095 51.6979 182.452H51.885C52.8164 180.086 53.1499 177.785 53.1244 175.663Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M62.0743 165.581C62.0226 165.307 61.8551 165.069 61.6163 164.928C61.3767 164.786 61.0876 164.755 60.8233 164.841C60.6493 164.898 56.5198 166.275 52.8477 169.842C52.7101 169.976 52.5732 170.115 52.4355 170.257C52.6307 170.992 52.7974 171.78 52.919 172.608C53.2992 172.154 53.7069 171.711 54.146 171.282C56.4143 169.062 58.9315 167.745 60.3318 167.122C60.5 168.735 60.6515 171.807 59.932 175.101C59.2883 178.047 58.1145 180.5 56.4252 182.451H58.3279C58.4939 182.451 58.657 182.474 58.8143 182.515C60.2226 180.541 61.2347 178.199 61.8216 175.514C62.9532 170.339 62.1107 165.773 62.0743 165.581Z"
        fill="#404851"
      />
      <path
        d="M46.6648 163.99C46.7241 163.899 46.7811 163.811 46.8374 163.727C46.7818 163.811 46.7241 163.899 46.6648 163.99Z"
        fill="#8BC34A"
      />
      <path
        d="M46.8913 163.645C46.9622 163.539 47.031 163.438 47.096 163.345C47.031 163.438 46.9622 163.539 46.8913 163.645Z"
        fill="#8BC34A"
      />
      <path
        d="M46.4143 164.387C46.4794 164.283 46.5431 164.182 46.6052 164.084C46.5431 164.182 46.4794 164.283 46.4143 164.387Z"
        fill="#8BC34A"
      />
      <path
        d="M46.115 164.884C46.1995 164.74 46.2825 164.602 46.3641 164.469C46.2825 164.602 46.1995 164.74 46.115 164.884Z"
        fill="#8BC34A"
      />
      <path
        d="M41.3987 171.845C41.1497 173.188 41.015 174.655 41.0798 176.205C41.1555 178.006 41.5021 179.917 42.2572 181.874C42.3315 182.066 42.4101 182.258 42.4924 182.452H44.6063C42.791 178.751 42.4917 174.714 43.7252 170.391C44.3551 168.182 45.293 166.284 46.1143 164.885C46.1143 164.885 46.1151 164.885 46.1151 164.884C46.1995 164.74 46.2825 164.602 46.3641 164.469C46.3808 164.441 46.3976 164.414 46.4151 164.387C46.4799 164.282 46.5432 164.182 46.6051 164.084C46.6255 164.052 46.6452 164.021 46.6656 163.99C46.7245 163.899 46.7813 163.811 46.8374 163.727C46.8556 163.699 46.8738 163.671 46.892 163.644C46.9626 163.539 47.0311 163.437 47.0959 163.344C48.0112 164.667 49.5578 167.209 50.4659 170.39C51.6994 174.713 51.4001 178.751 49.5848 182.451H51.6987C53.2038 178.918 53.3458 175.508 52.9198 172.608C52.7982 171.78 52.6314 170.993 52.4363 170.257C52.3948 170.099 52.3518 169.943 52.3074 169.79C50.8394 164.706 47.9581 161.243 47.8357 161.098C47.6522 160.879 47.3813 160.753 47.0959 160.753C46.8105 160.753 46.5396 160.879 46.3561 161.098C46.2352 161.241 43.4114 164.637 41.931 169.636C41.9157 169.688 41.8997 169.738 41.8851 169.79C41.6987 170.435 41.5327 171.122 41.3987 171.845Z"
        fill="#404851"
      />
      <path
        d="M50.4651 170.391C49.5571 167.21 48.0105 164.667 47.0951 163.345C47.0303 163.439 46.9619 163.539 46.8913 163.645C46.8738 163.671 46.8548 163.7 46.8366 163.727C46.7806 163.812 46.7238 163.899 46.6648 163.991C46.6451 164.021 46.6247 164.053 46.6044 164.085C46.5425 164.182 46.4791 164.283 46.4143 164.388C46.3976 164.416 46.3808 164.442 46.3633 164.47C46.2818 164.603 46.1988 164.74 46.1143 164.884C46.1143 164.884 46.1136 164.885 46.1136 164.886C45.2929 166.284 44.355 168.183 43.7245 170.391C42.4909 174.714 42.7902 178.752 44.6055 182.452H47.5102H49.5833C51.3993 178.751 51.6986 174.714 50.4651 170.391Z"
        fill="#88BE4A"
      />
      <g opacity="0.6">
        <g opacity="0.6">
          <g opacity="0.6">
            <g opacity="0.6">
              <g opacity="0.6">
                <g opacity="0.6">
                  <path
                    opacity="0.6"
                    d="M44.0849 170.494C44.7148 168.285 45.6526 166.386 46.474 164.988C46.474 164.987 46.4747 164.987 46.4747 164.987C46.5592 164.843 46.6422 164.705 46.7238 164.572C46.7405 164.544 46.7573 164.517 46.7748 164.49C46.8396 164.386 46.9029 164.284 46.9648 164.187C46.9852 164.155 47.0049 164.123 47.0252 164.093C47.0842 164.002 47.141 163.914 47.1971 163.829C47.2153 163.802 47.2335 163.773 47.2517 163.747C47.2721 163.716 47.291 163.689 47.3107 163.66C47.2364 163.548 47.1636 163.441 47.0959 163.342C47.0311 163.436 46.9626 163.537 46.892 163.643C46.8745 163.669 46.8556 163.697 46.8374 163.725C46.7813 163.81 46.7245 163.897 46.6655 163.988C46.6459 164.019 46.6255 164.051 46.6051 164.082C46.5432 164.18 46.4798 164.281 46.415 164.386C46.3983 164.413 46.3815 164.44 46.3641 164.467C46.2825 164.601 46.1995 164.738 46.115 164.882C46.115 164.882 46.1143 164.883 46.1143 164.884C45.2937 166.282 44.3558 168.181 43.7252 170.389C42.9264 173.19 42.7742 175.871 43.2577 178.418C42.9511 175.894 43.3043 173.231 44.0849 170.494Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M46.3641 164.47C46.3812 164.442 46.3983 164.415 46.4162 164.387C46.3983 164.415 46.3812 164.442 46.3641 164.47Z"
        fill="#616B6B"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M46.3641 164.47C46.3812 164.442 46.3983 164.415 46.4162 164.387C46.3983 164.415 46.3812 164.442 46.3641 164.47Z"
                    fill="#616B6B"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M46.8367 163.728C46.8553 163.701 46.8739 163.671 46.8925 163.644C46.8747 163.672 46.8553 163.701 46.8367 163.728Z"
        fill="#616B6B"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M46.8367 163.728C46.8553 163.701 46.8739 163.671 46.8925 163.644C46.8747 163.672 46.8553 163.701 46.8367 163.728Z"
                    fill="#616B6B"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M46.6051 164.084C46.6257 164.053 46.6455 164.021 46.666 163.99C46.6455 164.021 46.6249 164.053 46.6051 164.084Z"
        fill="#616B6B"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M46.6051 164.084C46.6257 164.053 46.6455 164.021 46.666 163.99C46.6455 164.021 46.6249 164.053 46.6051 164.084Z"
                    fill="#616B6B"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M46.1143 164.886C46.1143 164.885 46.1156 164.885 46.1156 164.884C46.1156 164.885 46.1143 164.885 46.1143 164.886Z"
        fill="#616B6B"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M46.1143 164.886C46.1143 164.885 46.1156 164.885 46.1156 164.884C46.1156 164.885 46.1143 164.885 46.1143 164.886Z"
                    fill="#616B6B"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M36.6671 184.389L40.6268 199.834H54.3688L58.3286 184.389H36.6671Z"
        fill="white"
      />
      <path
        d="M56.4259 182.452H51.6979H49.584H47.5109H44.6063H42.4931H42.2769H38.5712H36.6678C36.5018 182.452 36.3386 182.475 36.1814 182.516C35.7721 182.622 35.4037 182.86 35.1394 183.201C34.7731 183.674 34.6457 184.29 34.7942 184.871L38.754 200.316C38.9739 201.172 39.745 201.772 40.6283 201.772H54.3696C55.2528 201.772 56.0239 201.172 56.2439 200.316L60.2036 184.871C60.3522 184.291 60.2248 183.674 59.8585 183.201C59.5934 182.859 59.225 182.622 58.8157 182.516C58.6585 182.475 58.4954 182.452 58.3293 182.452H56.4259V182.452ZM54.3688 199.834H40.6268L36.6671 184.389H58.3286L54.3688 199.834Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <g opacity="0.3">
            <g opacity="0.3">
              <g opacity="0.3">
                <g opacity="0.3">
                  <path
                    opacity="0.3"
                    d="M243.466 220H26.5339C22.9251 220 20 217.071 20 213.458V213.4C20 209.787 22.9251 206.858 26.5339 206.858H243.466C247.075 206.858 250 209.787 250 213.4V213.458C249.999 217.071 247.074 220 243.466 220Z"
                    fill="#404851"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </BaseIcon>
  );
};

export default PersonWithCatIcon;
